api = require('../api.coffee').api()

class global.ContactsResource extends ResourceBase
  @MODEL = Contact
  @SINGULAR_RESOURCE_NAME = 'contact'
  @PLURAL_RESOURCE_NAME = 'contacts'

  constructor: (company_id) ->
    @company_id = company_id

  index: (success, failure, params = {}) ->
    api.get "/companies/#{@company_id}/contacts",
      params, {
        success: @collectionSuccess(success),
        failure: @collectionFailure(failure)
      }

  get: (success, failure, params = {}) ->
    api.get "/contacts/#{@getParamsId(params)}",
      params, {
        success: @memberSuccess(success),
        failure: failure
      }

  summary: (success, failure, params = {}) ->
    api.get "/contacts/#{@getParamsId(params)}/summary",
      params, {
        success: @memberSuccess(success),
        failure: failure
      }

  update: (success, failure, params = {}) ->
    api.put "/contacts/#{@getParamsId(params)}",
      params, {
        success: @memberSuccess(success),
        failure: failure
      }

  updateRecipient: (success, failure, params = {}) ->
    api.put "/contacts/#{params.contact_id}/recipients/#{@getParamsId(params)}",
            params,
            { success: @memberSuccess(success), failure: failure }

  resetRecipient: (success, failure, params = {}) ->
    api.put "/contacts/#{params.contact_id}/recipients/#{@getParamsId(params)}/reset",
            params, {
              success: @memberSuccess(success),
              failure: failure
            }

  eligibleForANewFlow: (success, failure, params = {}) ->
    api.get "/companies/#{@company_id}/contacts?q[eligible_for_a_new_flow]=1",
      params, {
        success: @collectionSuccess(success),
        failure: @collectionFailure(failure)
      }

  lastActiveOnFlow: (success, failure, params = {}) ->
    api.get "/companies/#{@company_id}/contacts?q[last_active_on_flow]=#{params.flow_id}",
      params, {
        success: @collectionSuccess(success),
        failure: @collectionFailure(failure)
      }

  withoutGroup: (success, failure, params = {}) ->
    api.get "/companies/#{@company_id}/contacts?q[without_group]=1",
      params, {
        success: @collectionSuccess(success),
        failure: @collectionFailure(failure)
      }

  import: (success, failure, params = {}) ->
    api.post "/companies/#{@company_id}/contacts/import",
      params,
      { success, failure }

  importCsv: (success, failure, params = {}) ->
    api.post "/companies/#{@company_id}/contacts/import_csv",
      params,
      { success, failure }

  validateImport: (success, failure, params = {}) ->
    api.post "/companies/#{@company_id}/contacts/validate_import",
      params,
      { success, failure }

  destroy: (success, failure, params = {}) ->
    api.delete "/contacts/#{@getParamsId(params)}", params, { success, failure }

  massActionPrepare: (success, failure, params = {}) ->
    api.post "/companies/#{@company_id}/contacts/mass_actions/prepare",
      params, {
        success,
        failure
      }

  massActionExecute: (success, failure, params = {}) ->
    api.post "/companies/#{@company_id}/contacts/mass_actions/execute",
      params, {
        success,
        failure
      }

  removeFromFlow: (success, failure, params = {}) ->
    api.post "/contacts/#{@getParamsId(params)}/remove_from_flow",
      params, {
        success: @memberSuccess(success),
        failure
      }

  groupContacts: (success, failure, params = {}) ->
    contact_group_id = params.params.contact_group_id
    delete params['contact_group_id']
    api.get "/contact_groups/#{contact_group_id}/contacts",
      params, {
        success: @collectionSuccess(success),
        failure
      }

  export: (success, failure, params = {}) ->
    api.post "/companies/#{@company_id}/contacts/export",
      params, { success: success, failure: failure }

  reengage: (success, failure, params = {}) ->
    api.post "/contacts/#{@getParamsId(params)}/reengage",
      params, {
        success: @memberSuccess(success),
        failure: failure
      }



// WEBPACK FOOTER //
// ./src/resources/contacts.coffee